import { ImageConstants } from "../_constants";
import { preloadImages } from "../_helpers";

const initialState = {
  loading: false,
  params: undefined,
  error: undefined,
  items: [],
};

export function images(state = initialState, action) {
  switch (action.type) {
    case ImageConstants.FETCH_WORLD_REQUEST:
    case ImageConstants.FETCH_CHRONICLE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        params,
      };
    }

    case ImageConstants.FETCH_WORLD_SUCCESS:
    case ImageConstants.FETCH_CHRONICLE_SUCCESS: {
      const { payload } = action;
      preloadImages(payload);
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: payload,
      };
    }

    case ImageConstants.FETCH_WORLD_FAILURE:
    case ImageConstants.FETCH_CHRONICLE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
        params: undefined,
      };
    }

    // Upload Images
    case ImageConstants.UPLOAD_IMAGE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case ImageConstants.UPLOAD_IMAGE_SUCCESS: {
      const { payload } = action;
      preloadImages([payload]);
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: [...state.items, ...payload],
      };
    }

    case ImageConstants.UPLOAD_IMAGE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        error,
        params: undefined,
      };
    }

    //Update
    case ImageConstants.UPDATE_IMAGE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case ImageConstants.UPDATE_IMAGE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload._id);
      preloadImages([state.items[oldItemIndex]], true);
      preloadImages([payload]);
      return {
        ...state,
        loading: false,
        error: undefined,
        params: undefined,
        items: [
          ...state.items.slice(0, oldItemIndex),
          payload,
          ...state.items.slice(oldItemIndex + 1),
        ],
      };
    }

    case ImageConstants.UPDATE_IMAGE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    // Delete
    case ImageConstants.DELETE_IMAGE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        error: undefined,
        params,
      };
    }

    case ImageConstants.DELETE_IMAGE_SUCCESS: {
      const { payload } = action;
      const oldItemIndex = state.items.findIndex((i) => i._id === payload);
      preloadImages([state.items[oldItemIndex]], true);
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: [
          ...state.items.slice(0, oldItemIndex),
          ...state.items.slice(oldItemIndex + 1),
        ],
      };
    }

    case ImageConstants.DELETE_IMAGE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    case ImageConstants.DELETE_MULTIPLE_IMAGE_REQUEST: {
      const { params } = action;
      return {
        ...state,
        loading: true,
        params,
        error: undefined,
      };
    }

    case ImageConstants.DELETE_MULTIPLE_IMAGE_SUCCESS: {
      const { payload } = action;
      const newItems = state.items.filter((item) =>
        payload.indexOf(item._id) > -1 ? false : true
      );
      const deletedItems = state.items.filter((item) =>
        payload.indexOf(item._id) > -1 ? true : false
      );
      preloadImages(deletedItems, true);
      return {
        ...state,
        loading: false,
        params: undefined,
        error: undefined,
        items: newItems,
      };
    }

    case ImageConstants.DELETE_MULTIPLE_IMAGE_FAILURE: {
      const { error } = action;
      return {
        ...state,
        loading: false,
        params: undefined,
        error,
      };
    }

    default: {
      return state;
    }
  }
}
